<app-breadcrumbs></app-breadcrumbs>
<main class="auto-height payment-wrapper buywifi-bgcolor">
    <section class="wrapper">
        <h2 tabindex="0" id="review-pay" class="reviewPay">{{'reviewAndPay' | translate}}</h2>
        <article class="large-4 medium-12 small-12 pull-right pad-t-22 round-wrap-parent">
            <div class="round-wrap wifiDetails">
                <h3 class="pad-b-10 wifiKeys">{{'wifiKeys' | translate}}</h3>
                <p class="pad-b-10" *ngIf="wifiKey > 1">{{wifiKey}} {{'sasWiFiKeys' | translate}}</p>
                <p class="pad-b-10" *ngIf="wifiKey === 1">{{wifiKey}} {{'wifiKey' | translate}}</p>
                <p class="pad-b-10 wifiOnD">{{'validFor' | translate}}
                    <span>{{currentSegment.departureAirport.name}}</span>
                    <span class="destination"> {{currentSegment.departureAirport.code}} - </span>
                    <span>{{currentSegment.arrivalAirport.name}}</span>
                    <span class="destination mrgn-l-5">{{currentSegment.arrivalAirport.code}},</span> {{currentSegment.marketingCarrierCode}}{{currentSegment.flightNumber}}</p>
            </div>
        </article>
        <app-payment-options></app-payment-options>

        <app-pay [wifiKey]='wifiKey' [maxretryError]='maxretryError' [price]='price'></app-pay>

    </section>
</main>
<div class="modal flight-info-detail error-in-modal" style="display: block !important; opacity: 1;" *ngIf="maxretryError">
    <div class="wrapper">
        <div class="modal-body">
            <div class="modal-content">
                <header>
                    <h3>
                        <span>{{'maxRetry.header' | translate}}</span>
                    </h3>
                    <button type="button" id="maxretry-close-button" role="menuitem" tabindex="0" class="modal-close" [attr.aria-label]="('close' | translate)" (keydown.enter)="backToView()" (keydown.tab)="nextKeyFocus($event, '#maxretry-goback-btn');" (click)="backToView()">× </button>
                </header>
                <p>
                    <span>{{'notification.paymentMaximumRetry' | translate}}</span>
                </p>
                <form class="cmp-wrap">
                    <div class="row-block">
                        <button type="button" class="btn medium primary" id="maxretry-goback-btn" tabindex="0" (keydown.tab)="nextKeyFocus($event, '#maxretry-close-button');" (keydown.enter)="backToView()" (click)="backToView()">{{'restartCTA' | translate}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>